import { QAltCanvas } from "../CoreApp/QAltCanvas";
import { SVG_AddDefs } from "./SVG_AddDefs";
import { SVG_CreateSVGElement } from "./SVG_CreateSVGElement";
import { Globals } from "../CoreApp/Globals";

export function doSVGRender() {
  var g = Globals._svgRenderInfo;
  var cp = g.fCanvasPanel;
  var curDoc = g.fCurDoc;
  var pp = g.fPublishPanel;
  var cropToChart = g.fCropToChart;

  pp.CalcCanvasParams(cropToChart);
  var svg = SVG_CreateSVGElement(pp.fPubWidth, pp.fPubHeight);
  SVG_AddDefs(svg);

  var altCanvas = new QAltCanvas();
  altCanvas.InitAltCanvas("SVG", svg, false); //,null,null);
  if (cropToChart) altCanvas.SetShift(pp.fShiftX, pp.fShiftY);

  cp.SetAltCanvas(altCanvas);
  curDoc.ClearPictureFault();
  cp.RenderElements();
  cp.SetAltCanvas(null);

  var picFault = curDoc.GetPictureFault();
  if (picFault > 0)
    setTimeout(function () {
      doSVGRender();
    }, 250);
  else pp.FinishPublishSVG(svg);
}
